import type { Customer } from './customer'
import type { Partner } from './partner'

export enum SubscriptionSourceType {
    coupon = 'coupon',
    credential = 'credential'
}

export interface Subscription {
    id?: string
    customer_id?: string
    customer?: Customer
    partner_id?: string
    partner?: Partner
    invoice_id?: string
    source_id?: string
    source_type?: SubscriptionSourceType
    source_values?: string[]
    is_active?: boolean
    created_at?: string
    expires_at?: string
    ends_at?: string
}
